module.exports = __webpack_public_path__ + "static/media/s2.f2b7e4c9.png";